// CopyContext.js
import { createContext } from "react";

// We add dummy functions here just in case the card is ever
// rendered outside of the Copytrade page. It prevents the app from crashing!
export const CopyModalContext = createContext({
  setIsModalOpen: () => {},
  setSelectedTrader: () => {},
});
